import React from "react";
import { ChevronsUpDown, Check, Phone } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { useNumbers } from "@/context/NumberContext";

export const NumberSwitcher = () => {
  const { numbers, selectedId, selectedNumber, setSelectedId } = useNumbers();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="number-switcher-trigger"
          className="w-full flex items-center gap-2.5 rounded-lg border border-slate-200 bg-white px-3 py-2.5 hover:bg-slate-50 transition-colors text-left focus:outline-none focus:ring-2 focus:ring-emerald-500"
        >
          <span className="h-8 w-8 rounded-lg bg-emerald-600 flex items-center justify-center shrink-0">
            <Phone className="h-4 w-4 text-white" strokeWidth={2.4} />
          </span>
          <span className="min-w-0 flex-1 leading-tight">
            <span className="block text-sm font-semibold text-slate-900 truncate">
              {selectedNumber?.line_name || "Toutes les lignes"}
            </span>
            <span className="block text-xs text-slate-400 tabular-nums truncate">
              {selectedNumber?.number || "Les deux numéros"}
            </span>
          </span>
          <ChevronsUpDown className="h-4 w-4 text-slate-400 shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[248px]" align="start">
        <DropdownMenuLabel className="text-xs text-slate-400 uppercase tracking-[0.05em]">
          Mes lignes
        </DropdownMenuLabel>
        <DropdownMenuItem
          data-testid="switch-number-all"
          onClick={() => setSelectedId("all")}
          className="cursor-pointer py-2"
        >
          <div className="flex items-center gap-2 w-full">
            <div className="min-w-0 flex-1 leading-tight">
              <p className="text-sm font-medium text-slate-800 truncate">Toutes les lignes</p>
              <p className="text-xs text-slate-400 tabular-nums truncate">Les deux numéros</p>
            </div>
            {selectedId === "all" && (
              <Check className="h-4 w-4 text-emerald-600 shrink-0" />
            )}
          </div>
        </DropdownMenuItem>
        {numbers.map((n) => (
          <DropdownMenuItem
            key={n.id}
            data-testid={`switch-number-${n.id}`}
            onClick={() => setSelectedId(n.id)}
            className="cursor-pointer py-2"
          >
            <div className="flex items-center gap-2 w-full">
              <div className="min-w-0 flex-1 leading-tight">
                <p className="text-sm font-medium text-slate-800 truncate">{n.line_name}</p>
                <p className="text-xs text-slate-400 tabular-nums truncate">{n.number}</p>
              </div>
              {selectedNumber?.id === n.id && (
                <Check className="h-4 w-4 text-emerald-600 shrink-0" />
              )}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
